import React, { FC } from "react";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { OrgColumn } from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { UserOrgColumn } from "../../../interfaces/SuperAdmin/Pages/iDataUserOrganization";

interface Props {
  label: string;
  column: OrgColumn | UserOrgColumn;
  handleSort: any
  orderBy: OrgColumn | UserOrgColumn | null;
  orderDirection: "asc" | "desc";
}

const SortedHeaderCell: FC<Props> = ({
  label,
  column,
  handleSort,
  orderBy,
  orderDirection,
}) => {
  return (
    <StyledTableCell>
      <span onClick={() => handleSort(column)} style={{ cursor: "pointer" }}>
        {label}{" "}
        {orderBy === column &&
          (orderDirection === "asc" ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          ))}
      </span>
    </StyledTableCell>
  );
};

export default SortedHeaderCell;
